import React from "react";
import Switch from "./Switch.js";
import SideBarFilter from "./SideBarFilter.jsx";
import SearchBox from "./SearchBox.js";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../actions/Actions.js";
import Helper from "../functions/Helper.js";
import { useNavigate } from "react-router-dom";
import queryString from "query-string";
import FilterBadge from "./FilterBadge.js";

function FilterContainer(props) {
  const navigate = useNavigate();

  const updateFilters = (filters, filterType) => {
    //filters is an array for example "Nike,Jordan" or ">7.8,<9.5"
    //filtertype is string "traction","cushion","release_date" etc
    let nextFilterObject = Helper.nextFilterObject(props.filterObject, {
      [filterType]: filters.join(","),
    });
    let nextUrl = Helper.getNextUrl(nextFilterObject, props.urlMapping);
    Helper.gaEvent("reviews", "filter", filterType);
    Helper.ga4Event("reviews", { filterType: filterType });
    navigate(nextUrl);
  };

  const resetFilters = () => {
    let nextFilterObject = {};
    if (props.filterObject.sortBy) {
      nextFilterObject.sortBy = props.filterObject.sortBy;
    }
    if (props.filterObject.order) {
      nextFilterObject.order = props.filterObject.order;
    }
    let nextUrl = queryString.stringify(nextFilterObject);
    props.actions.collapseAllFilters();
    navigate("/shoe-reviews/" + Helper.addQuestionMark(nextUrl));
  };

  return (
    <div id="filter_sidebar" style={{}}>
      <div style={{ paddingBottom: 10 }}>
        <div>
          <Switch
            values={["ALL SHOES", "FAVOURITES"]}
            active={props.switchValue}
            onChanged={(x) => {
              if (x) {
                updateFilters(
                  props.favs.length > 0 ? props.favs : ["none"],
                  "favs"
                );
              } else {
                updateFilters([], "favs");
              }
              props.actions.switchValue(x);
            }}
          />
        </div>

        <div style={{ paddingTop: 15, paddingBottom: 10 }}>
          <SearchBox
            onEditing={() => {
              if (!props.filtering) {
                props.actions.editing();
              }
            }}
            searchText={props.searchText}
            onChange={(x) => {
              props.actions.searchtext(x);
              updateFilters([x], "shoe_name");
            }}
          />
        </div>
        <div style={{}}>
          {Object.entries(props.filterObject).map((x) => (
            <FilterBadge
              key={x[0]}
              updateFilters={updateFilters}
              filterType={props.filterArray.find((y) => y.data === x[0])}
              filterKey={x[0]}
              filterValue={x[1]}
            />
          ))}
        </div>
      </div>

      {Helper.validFilterLength(props.filterArray, props.filterObject) > 0 && (
        <div
          style={{ display: "flex", marginBottom: 20, alignItems: "center" }}
        >
          <div
            onClick={() => {
              resetFilters();
            }}
            style={{
              flex: 1,
              fontWeight: "bold",
              color: "rgb(197, 48, 48)",
              cursor: "pointer",
            }}
          >
            <i
              style={{ fontSize: 16, marginRight: 5 }}
              className="far fa-trash-alt"
            ></i>
            <span style={{ fontSize: 14, fontWeight: 600 }}>
              Clear All Filters
            </span>
          </div>
        </div>
      )}

      {props.filterArray.map((filter) => {
        let matchingFilterString =
          props.filterObject[filter.data]?.split(",") ?? [];
        let additionalData = {};
        if (filter.type === "date") {
          let maxDate = new Date();
          let minDate = props.stats.min_date
            ? Helper.getDateFromMysql(props.stats.min_date)
            : new Date();
          additionalData = { minDate: minDate, maxDate: maxDate };
        }

        return (
          <SideBarFilter
            matchingFilterString={matchingFilterString}
            collapse={(x) =>
              props.actions.collapse_filter({ filter: filter.data, state: x })
            }
            collapsed={props.filterExpanded[filter.data]}
            updateFilters={updateFilters}
            key={filter.data}
            {...additionalData}
            filterType={filter}
          />
        );
      })}
    </div>
  );
}

export default connect(
  (state) => ({ ...state.data, ...state.persistData }),
  (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
  })
)(FilterContainer);
